import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import ExceptionFilterItem from "./ExceptionFilterItem"
import { EExceptionUITypes } from "../../models"
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert"
import SelectShowFilterItemMenu from "./SelectShowFilterItemMenu"
import * as exceptionHelper from "../../helpers/exceptionHelper"

interface IProps {
	showFilterTypes: EExceptionUITypes[]
	selectedFilterTypes: EExceptionUITypes[]
	backgroundColor?: string
	missPunch: number
	noEmpApprove: number
	noSupApprove: number
	bioException: number
	locException: number
	prePunchScreeningException: number
	scheduleMissingInPunchException: number
	scheduleEarlyInPunchException: number
	scheduleLateInPunchException: number
	scheduleEarlyOutPunchException: number
	scheduleLateOutPunchException: number
	scheduleMissingBreakException: number
	scheduleLongBreakException: number
	scheduleNoShiftException: number
	timeoff: number // it's unapproved timeoff requests
	suspensePunch: number
	timeFraud: number
	handleShowFilterTypes(showFilterTypes: EExceptionUITypes[]): void
	handleSelectFilterType(clickedFilterType: EExceptionUITypes): void
}
interface IState {
	showFilterOptionMenu: boolean
}

export default class ExceptionFilter extends React.Component<IProps, IState> {
	private allFilterItems: EExceptionUITypes[]
	private localStorageKey = "ShowExceptionFilterItems"
	constructor(props: IProps) {
		super(props)
		this.allFilterItems = exceptionHelper.getExceptionFilterAllItems()
		this.state = {
			showFilterOptionMenu: false
		}
		autobind(this)
	}

	getTopTitle(item: EExceptionUITypes) {
		switch (item) {
			case EExceptionUITypes.MissPunch:
				return strings.Missing.toUpperCase()
			case EExceptionUITypes.NoEmpApprove:
				return `${strings.No.toUpperCase()} ${strings.Employee.toUpperCase()}`
			case EExceptionUITypes.NoSupApprove:
				return `${strings.No.toUpperCase()} ${strings.Supervisor.toUpperCase()}`
			case EExceptionUITypes.BioException:
				return strings.Biometric.toUpperCase()
			case EExceptionUITypes.LocException:
				return strings.Location.toUpperCase()
			case EExceptionUITypes.ScheduleMissingInPunch:
				return strings.Missed.toUpperCase()
			case EExceptionUITypes.ScheduleEarlyInPunch:
				return strings.Early.toUpperCase()
			case EExceptionUITypes.ScheduleLateInPunch:
				return strings.Late.toUpperCase()
			case EExceptionUITypes.ScheduleEarlyOutPunch:
				return strings.Early.toUpperCase()
			case EExceptionUITypes.ScheduleLateOutPunch:
				return strings.Late.toUpperCase()
			case EExceptionUITypes.ScheduleLongBreak:
				return strings.Long.toUpperCase()
			case EExceptionUITypes.ScheduleMissingBreak:
				return strings.Missed.toUpperCase()
			case EExceptionUITypes.ScheduleNoShift:
				return strings.No.toUpperCase()
			case EExceptionUITypes.QuestionException:
				return strings.Quest_Fail.toUpperCase()
			case EExceptionUITypes.Timeoff:
				return strings.Unapproved.toUpperCase()
			case EExceptionUITypes.SuspensePunch:
				return strings.Suspense.toUpperCase()
			case EExceptionUITypes.TimeFraud:
				return strings.Time.toUpperCase()
		}
	}

	getBottomTitle(item: EExceptionUITypes) {
		switch (item) {
			case EExceptionUITypes.MissPunch:
				return strings.Punches.toUpperCase()
			case EExceptionUITypes.NoEmpApprove:
				return strings.Approval.toUpperCase()
			case EExceptionUITypes.NoSupApprove:
				return strings.Approval.toUpperCase()
			case EExceptionUITypes.BioException:
				return strings.Low_Score.toUpperCase()
			case EExceptionUITypes.LocException:
				return strings.Boundary.toUpperCase()
			case EExceptionUITypes.ScheduleMissingInPunch:
				return strings.In.toUpperCase()
			case EExceptionUITypes.ScheduleEarlyInPunch:
				return strings.In.toUpperCase()
			case EExceptionUITypes.ScheduleLateInPunch:
				return strings.In.toUpperCase()
			case EExceptionUITypes.ScheduleEarlyOutPunch:
				return strings.Out.toUpperCase()
			case EExceptionUITypes.ScheduleLateOutPunch:
				return strings.Out.toUpperCase()
			case EExceptionUITypes.ScheduleLongBreak:
				return strings.Break.toUpperCase()
			case EExceptionUITypes.ScheduleMissingBreak:
				return strings.Break.toUpperCase()
			case EExceptionUITypes.ScheduleNoShift:
				return strings.Shift.toUpperCase()
			case EExceptionUITypes.QuestionException:
				return strings.Punch.toUpperCase()
			case EExceptionUITypes.Timeoff:
				return strings.Timeoff_Request.toUpperCase()
			case EExceptionUITypes.SuspensePunch:
				return strings.Punch.toUpperCase()
			case EExceptionUITypes.TimeFraud:
				return strings.Fraud.toUpperCase()
		}
	}

	handleUpdateShowFilterTypes(event, value) {
		const item = event.target.name as EExceptionUITypes
		const showFilterTypes = this.props.showFilterTypes
		if (value) {
			showFilterTypes.push(item)
		}
		else {
			showFilterTypes.splice(showFilterTypes.indexOf(item), 1)
			this.props.selectedFilterTypes.indexOf(item) > -1 && this.props.handleSelectFilterType(item)
		}
		localStorage.setItem(`findd_${this.localStorageKey}`, showFilterTypes.length ? showFilterTypes.toString() : "none")
		this.props.handleShowFilterTypes(showFilterTypes)
	}

	render() {
		return (
			<div style={{ display: "flex" }}>
				<div style={{ overflowX: "auto", flex: 1 }}>
					<div style={{ display: "flex", backgroundColor: this.props.backgroundColor, justifyContent: "space-between" }}>
						{this.props.showFilterTypes.map((item, index) =>
							<ExceptionFilterItem
								key={index}
								type={item}
								selected={this.props.selectedFilterTypes.find(selectedType => item === selectedType) !== undefined}
								count={this.props[item]}
								topTitle={this.getTopTitle(item)}
								bottomTitle={this.getBottomTitle(item)}
								handleSelect={this.props.handleSelectFilterType}
							/>
						)}
					</div>
				</div>
				<div style={{ backgroundColor: this.props.backgroundColor, height: 80, width: 50, textAlign: "center", position: "relative" }}>
					<MoreVertIcon
						data-intercom-target={"ExceptionFilter-Btn-VertIcon"}
						style={{ marginTop: 15 }}
						onClick={() => this.setState({ showFilterOptionMenu: !this.state.showFilterOptionMenu })}
					/>					
					{this.state.showFilterOptionMenu &&
						<SelectShowFilterItemMenu
							allFilterItems={this.allFilterItems}
							showFilterItems={this.props.showFilterTypes}
							handleUpdateShowFilterItems={this.handleUpdateShowFilterTypes}
						/>
					}
				</div>
			</div>
		)
	}
}
